<template>
  <div>



    <b-tabs vertical content-class="col-12 col-md-9 mt-1 mt-md-0" pills
        nav-wrapper-class="col-md-3 col-12" nav-class="nav-left">



      <!-- users tab -->
      <b-tab>
        <!-- title -->
        <template #title>
          <feather-icon icon="CodesandboxIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('hidden Widgets settings')}}</span>
        </template>
        <roles-tab :user="33"></roles-tab>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BButton, BTable, BTabs, BTab } from 'bootstrap-vue'

import RolesTab from "@/views/dashboard/settings/HiddenWidgets.vue"

import { OrbitSpinner } from 'epic-spinners'
import store from '@/store'

export default {
  props: ['user'],
  components: {
    BButton,
    BTable, 
    BTabs, BTab, OrbitSpinner,
    RolesTab

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
